/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Who_WcInputs */

const en_wc_vs_who_wc = /** @type {(inputs: Wc_Vs_Who_WcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose WordCraft if you`)
};

/**
* | output |
* | --- |
* | "Choose WordCraft if you" |
*
* @param {Wc_Vs_Who_WcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_who_wc = /** @type {((inputs?: Wc_Vs_Who_WcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Who_WcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_who_wc(inputs)
});
export { wc_vs_who_wc as "wc.vs.who_wc" }